var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentDefault28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9167 8.49333V5.83333C23.9167 4.55 22.8667 3.5 21.5834 3.5H5.25008C3.95508 3.5 2.91675 4.55 2.91675 5.83333V22.1667C2.91675 23.45 3.95508 24.5 5.25008 24.5H21.5834C22.8667 24.5 23.9167 23.45 23.9167 22.1667V19.5067C24.6051 19.0983 25.0834 18.3633 25.0834 17.5V10.5C25.0834 9.63667 24.6051 8.90167 23.9167 8.49333ZM22.7501 10.5V17.5H14.5834V10.5H22.7501ZM5.25008 22.1667V5.83333H21.5834V8.16667H14.5834C13.3001 8.16667 12.2501 9.21667 12.2501 10.5V17.5C12.2501 18.7833 13.3001 19.8333 14.5834 19.8333H21.5834V22.1667H5.25008Z",
    fill: "#B7C2CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0834 15.75C19.0499 15.75 19.8334 14.9665 19.8334 14C19.8334 13.0335 19.0499 12.25 18.0834 12.25C17.1169 12.25 16.3334 13.0335 16.3334 14C16.3334 14.9665 17.1169 15.75 18.0834 15.75Z",
    fill: "#B7C2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentDefault28);
export default __webpack_public_path__ + "static/media/investment_default_28.cac43bb8927f37a1147a61b7e41670c5.svg";
export { ForwardRef as ReactComponent };